<template>
  <div class="BCT">
    <div class="container">
      <h2>MCT介绍</h2>
      <p>医学汉语水平考试 (MCT) 是一项考查医学汉语应用水平的标准化语言测试，由孔子学院总部、汉考国际联合国内五所重点医学院校共同研制。医学汉语水平考试 (MCT)主要面向医学专业留学生、在中国境外用汉语进行医学专业学习的学生，以及在中国境内外用汉语进行临床诊疗的汉语非第一语言医护工作人员，考查其在医学/医疗场景中与患者、医护人员及相关人员用汉语进行交际的能力。</p>
      <div class="shenqingTit">一、能力描述</div>
      <p>MCT一级：能够大体理解与医院日常交际场景相关的、基本的语言材料。能够就病情进行简单的交流与沟通，能对疾病的基本情况进行简单描述。汉语水平能够基本满足医院实习的要求。医学专业词汇量为400左右。</p>
      <p>MCT二级：能够理解与医院日常交际场景相关的、较为具体的语言材料。能够就病情进行较为复杂的交流与沟通，能对疾病的主要情况进行较为具体的描述。汉语水平能够总体满足医院实习的要求。医学专业词汇量为800左右。</p>
      <p>MCT三级：能够完全理解与医院日常交际场景相关的绝大部分语言材料。能够就病情进行复杂的交流与沟通，能对疾病的整体情况进行详细描述。汉语水平能够完全满足医院实习的要求。医学专业词汇量为1500左右。</p>
      <div class="shenqingTit">二、考试内容</div>
      <p>医学汉语水平考试 (MCT) 试卷分听力、阅读和写作三部分，各部分满分为100分，总分300分。全卷共101题，考试时间约125分钟 (含考生填写个人信息时间5 分钟 )。</p>
      <div class="kaoshi-fenlei">
        <div class="__contss">
          <div class="_table">
            <div class="_row _thead">
              <div class="_col w55">
                <div class="_text">试卷结构</div>
              </div>
              <div class="_col w15">
                <div class="_text">题量(个)</div>
              </div>
              <div class="_col w15">
                <div class="_text">分数</div>
              </div>
              <div class="_col w15">
                <div class="_text">时间(分钟)</div>
              </div>
            </div>
            <div class="_row">
              <div class="_col w5">
                <div class="_text z4">听力</div>
              </div>
              <div class="_col w50">
                <div class="_text">听句子，判断对错。</div>
                <div class="_text">听对话，选择正确答案。</div>
                <div class="_text">听对话，选择正确答案。</div>
                <div class="_text">听短文，选择正确答案。</div>
              </div>
              <div class="_col w15">
                <div class="_text">10</div>
                <div class="_text">10</div>
                <div class="_text">10</div>
                <div class="_text">20</div>
              </div>
              <div class="_col w15">
                <div class="_text z4">100</div>
              </div>
              <div class="_col w15">
                <div class="_text z4">约35</div>
              </div>
            </div>
            <div class="_row">
              <div class="_col w5">
                <div class="_text z4">阅读</div>
              </div>
              <div class="_col w50">
                <div class="_text">选择正确的词语填空。</div>
                <div class="_text">阅读语段，选择与语段意思一致的一项。</div>
                <div class="_text">阅读材料，选择正确答案。</div>
                <div class="_text">阅读短文，选出正确答案。</div>
              </div>
              <div class="_col w15">
                <div class="_text">10</div>
                <div class="_text">10</div>
                <div class="_text">10</div>
                <div class="_text">20</div>
              </div>
              <div class="_col w15">
                <div class="_text z4">100</div>
              </div>
              <div class="_col w15">
                <div class="_text z4">50</div>
              </div>
            </div>
            <div class="_row">
              <div class="_col w5">
                <div class="_text">写作</div>
              </div>
              <div class="_col w50">
                <div class="_text">根据一段长对话完成门诊病历记录。</div>
              </div>
              <div class="_col w15">
                <div class="_text">1</div>
              </div>
              <div class="_col w15">
                <div class="_text">100</div>
              </div>
              <div class="_col w15">
                <div class="_text">30</div>
              </div>
            </div>
            <div class="_row">
              <div class="_col w25">
                <div class="_text">共计</div>
              </div>
              <div class="_col w25">
                <div class="_text">101</div>
              </div>
              <div class="_col w25">
                <div class="_text">300</div>
              </div>
              <div class="_col w25">
                <div class="_text">120</div>
              </div>
            </div>
          </div>
          <div class="shenqingTit">三、成绩报告</div>
          <p>考试结束后一个月，考生可登录汉语考试服务网，输入准考证号码和姓名查询成绩（www.chinesetest.cn）。</p>
          <div class="_table">
            <div class="_row _thead">
              <div class="_col w50">
                <div class="_text">分数</div>
              </div>
              <div class="_col w50">
                <div class="_text">能力等级</div>
              </div>
            </div>
            <div class="_row ">
              <div class="_col w50">
                <div class="_text">100-149</div>
              </div>
              <div class="_col w50">
                <div class="_text">一级</div>
              </div>
            </div>
            <div class="_row ">
              <div class="_col w50">
                <div class="_text">150-199</div>
              </div>
              <div class="_col w50">
                <div class="_text">二级</div>
              </div>
            </div>
            <div class="_row ">
              <div class="_col w50">
                <div class="_text">200-300</div>
              </div>
              <div class="_col w50">
                <div class="_text">三级</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="botline">
      没有更多了
    </div>
    <van-popup v-model="showForm"
               position="bottom"
               @closed="clearForm"
               :style="{ height: 'max-contant',maxHeight:'70%' }">
      <div class="FormCont">
        <ComForm @hideForm="hideForm"
                 :typeId=formType
                 :formTitle="formtit"
                 ref="comForm"></ComForm>
      </div>
    </van-popup>
    <van-popup v-model="showForm2"
               position="bottom"
               @closed="clearForm"
               :style="{ height: 'max-contant',maxHeight:'70%' }">
      <div class="FormCont">
        <HSKForm @hideForm="hideForm"
                 ref="HSKForm"></HSKForm>
      </div>
    </van-popup>
    <van-popup v-model="showForm3"
               position="bottom"
               @closed="clearForm"
               :style="{ height: 'max-contant',maxHeight:'70%' }">
      <div class="FormCont">
        <BCTForm @hideForm="hideForm"
                 ref="BCTForm"></BCTForm>
      </div>
    </van-popup>
  </div>
</template>

<script>
// @ is an alias to /src
import ComForm from '@/components/ComForm'
import HSKForm from '@/components/HSKForm'
import BCTForm from '@/components/BCTForm'

export default {
  name: 'Jieji',
  components: {
    ComForm,
    HSKForm,
    BCTForm
  },
  data () {
    return {
      activeNames: ['0'],
      showForm: false,
      showForm2: false,
      showForm3: false,
      formtit: '',
      formType: ''
    }
  },
  methods: {
    hideForm () {
      this.showForm = false
      this.showForm2 = false
      this.showForm3 = false
    },
    clearForm () {
      this.$refs.comForm.clearForm()
    },
    onShowForm (id, val) {
      this.formType = id
      this.formtit = val
      this.showForm = true
    }
  }
}
</script>

<style lang="scss" scoped>
.Jieji {
  height: 100%;
  overflow: auto;
}
h2 {
  text-align: center;
}
p {
  margin-bottom: 20px;
  font-size: 28px;
  text-indent: 2em;
  &._c {
    text-align: center;
    text-indent: 0;
  }
  &.ted0 {
    text-indent: 0;
  }
}
.container {
  padding-bottom: 0;
  h4 {
    margin: 0;
  }
  font-size: 28px;

  .tips {
    color: #f29810;
    margin: 10px 0;
  }
  .tips_p {
    color: #545454;
  }
  .tips_lis {
    margin-top: 10px;
    color: #545454;
  }
  .tit1 {
    font-size: 32px;
    font-weight: bold;
    color: #f29810;
    text-align: center;
    margin-bottom: 20px;
  }
  .buzhu {
    h3 {
      margin-bottom: 20px;
      color: #263e65;
    }
    .lis {
      padding: 20px;
      box-shadow: 0px 0px 10px rgba($color: #000000, $alpha: 0.2);
    }
    p {
      text-indent: 0;
      margin: 0;
      margin-top: 20px;
      color: #545454;
      font-size: 26px;
      a {
        color: #263e65;
      }
    }
  }
  .shenqingTit {
    border-left: 10px solid #263e65;
    line-height: 1;
    font-size: 32px;
    margin: 30px 0;
    padding-left: 10px;
  }
}

.cont-card {
  padding: 20px 0;
}

._baoming {
  padding: 20px;
  p {
    text-indent: 0;
    text-align: center;
  }
}
._lis {
  box-shadow: 0px 0px 10px rgba($color: #000000, $alpha: 0.2);
  border-radius: 15px;
  margin-bottom: 40px;
  overflow: hidden;
  .text {
    padding: 20px;
    h5 {
      font-size: 36px;
      margin: 0;
      margin-bottom: 20px;
      color: #333;
    }
    p {
      text-indent: 0;
      color: #545454;
    }
  }
}
.kaoshi-fenlei {
  .kaoshi-cont {
    padding: 20px;
    h3 {
      font-size: 32px;
      margin-bottom: 20px;
      span {
        font-size: 58px;
        color: #263e65;
        margin-right: 10px;
      }
    }
    p {
      text-indent: 0;
      color: #545454;
    }
  }
  .btns {
    ._btn {
      display: block;
      background-color: #f6cb47;
      color: #fff;
      border-radius: 10px;
      padding: 20px 0;
      text-align: center;
      margin: 0 auto;
      margin-top: 20px;
      width: 95%;
    }
  }
}

.__contss {
  padding: 20px 0;
  ._table {
    width: 660px;
    margin: auto;
    border: 1px solid #dedede;
    margin-bottom: 10px;
    ._thead {
      background-color: #f1f1f1;
    }
    ._row {
      display: flex;
    }
    .w5 {
      width: 33px;
    }
    .w10 {
      width: 66px;
    }
    .w45 {
      width: 297px;
    }
    .w20 {
      width: 132px;
    }
    .w33 {
      width: 220px;
    }
    .w25 {
      width: 165px;
    }
    .w50 {
      width: 330px;
    }
    .w75 {
      width: 495px;
    }
    .w15 {
      width: 99px;
    }
    .w55 {
      width: 363px;
    }
    ._col {
      border-right: 1px solid #dedede;
      border-bottom: 1px solid #dedede;
      margin-bottom: -1px;
      box-sizing: border-box;
      font-size: 24px;
      &:last-child {
        border-right: none;
      }
    }
    ._text {
      box-sizing: border-box;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      height: 100px;
      padding: 0 10px;
      text-align: center;
    }
    .z2 {
      height: 200px;
    }
    .z3 {
      height: 300px;
    }
    .z4 {
      height: 400px;
    }
  }
}
</style>
<style lang="scss">
.van-step--finish .van-step__circle,
.van-step--finish .van-step__line {
  background-color: #263e65;
}
</style>
